import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fill={color} fillRule="nonzero" d="M24 6v14H9l2-2h11V8h-1l2-2z" />
      <path stroke={color} strokeWidth="2" d="M3 19V7h4l2-3h9M13 15c1.6569 0 3-1.3431 3-3" />
      <path d="M13 9c-1.6569 0-3 1.3431-3 3M1 21 21 1" stroke={color} strokeWidth="2" />
    </g>
  </svg>
);
